import { useMemo } from 'react'
import { ClipboardCheck } from 'lucide-react'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Skeleton } from '@/components/ui/skeleton'
import { IssueCard } from '@/components/kanban/issue-card'
import { ViewHeader } from '@/components/shell/view-header'
import { useOpenIssueSheet } from '@/hooks/use-ui-state'
import { useViewFilters } from '@/hooks/use-view-filters'
import { useIssues } from '@/lib/query'
import { ViewError } from '@/components/common/query-states'
import { EmptyState } from '@/components/common/empty-state'
import { TRIAGE_VIEW } from '@/lib/views'

export default function Triage() {
  const { data: issues, isPending, isError, error, refetch } = useIssues()
  const openIssue = useOpenIssueSheet()
  const chipFilter = useViewFilters()

  const items = useMemo(() => {
    return chipFilter
      .apply(TRIAGE_VIEW.pool(issues ?? [], {}))
      .sort((a, b) => a.createdAt.localeCompare(b.createdAt))
  }, [issues, chipFilter])

  return (
    <div className="flex h-full flex-col">
      <ViewHeader
        title="Triage"
        meta={`${items.length} items · oldest first · click a card to triage it`}
      />
      {isError ? (
        <ViewError what="issues" error={error} onRetry={() => refetch()} />
      ) : (
      <ScrollArea className="min-h-0 flex-1">
        <div className="mx-auto flex max-w-2xl flex-col gap-2 p-4">
          {isPending ? (
            Array.from({ length: 5 }, (_, i) => <Skeleton key={i} className="h-24 w-full" />)
          ) : items.length === 0 ? (
            <EmptyState
              bordered
              className="mt-10"
              icon={<ClipboardCheck className="text-faint-foreground size-6" />}
              title="No items in Triage"
            />
          ) : (
            items.map((issue) => (
              <IssueCard key={issue.id} issue={issue} onOpen={openIssue} />
            ))
          )}
        </div>
      </ScrollArea>
      )}
    </div>
  )
}
